import { useState, useRef } from 'react';
import { useLang } from '../../config/i18n';

export function CloudSetupModal({ onClose, onSave, existing, onDisconnect }){
  const [url,     setUrl]     = useState(existing?.url||"");
  const [anonKey, setAnonKey] = useState(existing?.anonKey||"");
  const [step,    setStep]    = useState(existing ? "connected" : 1);
  const [testing, setTesting] = useState(false);
  const [testErr, setTestErr] = useState("");

  const SQL = `CREATE TABLE IF NOT EXISTS findre_data (\n  key text PRIMARY KEY,\n  value jsonb,\n  updated_at timestamptz DEFAULT now()\n);`;

  async function testAndSave(){
    if(!url||!anonKey){ setTestErr("أدخل الرابط والمفتاح أولاً"); return; }
    setTesting(true); setTestErr("");
    try {
      // Try to create table via RPC or just do a select to test connection
      const res = await fetch(`${url.trim()}/rest/v1/findre_data?limit=1`, {
        headers:{ "apikey":anonKey.trim(), "Authorization":`Bearer ${anonKey.trim()}` }
      });
      if(res.status===200||res.status===206){
        onSave({ url:url.trim(), anonKey:anonKey.trim() });
      } else if(res.status===404||res.status===400){
        setTestErr("الجدول غير موجود — نفّذ SQL في الخطوة ٢ أولاً");
      } else {
        setTestErr(`خطأ في الاتصال (${res.status}) — تحقق من الرابط والمفتاح`);
      }
    } catch(e){ setTestErr("تعذّر الاتصال — تحقق من الرابط"); }
    setTesting(false);
  }

  const IS = { width:"100%", background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:9, padding:"9px 12px", color:"#e2e8f0", fontSize:12, outline:"none", fontFamily:"monospace", direction:"ltr", textAlign:"left", boxSizing:"border-box" };

  return(
    <div style={{position:"fixed",inset:0,zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.82)",backdropFilter:"blur(6px)"}}>
      <div dir="rtl" style={{background:"#181b27",border:"1px solid rgba(167,139,250,0.3)",borderRadius:20,width:"min(540px,94vw)",maxHeight:"90vh",overflowY:"auto",padding:30,fontFamily:"'Tajawal',sans-serif"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <span style={{fontSize:17,fontWeight:800,color:"#a78bfa"}}>☁️ ربط قاعدة بيانات Supabase</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#64748b",fontSize:20,cursor:"pointer"}}>✕</button>
        </div>

        {step==="connected" ? (
          <div>
            <div style={{background:"rgba(34,197,94,0.08)",border:"1px solid rgba(34,197,94,0.25)",borderRadius:12,padding:"16px 18px",marginBottom:16,textAlign:"center"}}>
              <div style={{fontSize:28,marginBottom:6}}>✅</div>
              <div style={{fontSize:15,fontWeight:700,color:"#22c55e",marginBottom:4}}>متصل بـ Supabase</div>
              <div style={{fontSize:11,color:"#64748b",direction:"ltr"}}>{existing?.url}</div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setStep(1)} style={{flex:1,padding:"10px",borderRadius:10,background:"rgba(200,160,60,0.1)",border:"1px solid rgba(200,160,60,0.2)",color:"#c8a03c",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>تحديث الإعدادات</button>
              <button onClick={onDisconnect} style={{flex:1,padding:"10px",borderRadius:10,background:"rgba(239,68,68,0.09)",border:"1px solid rgba(239,68,68,0.2)",color:"#ef4444",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>قطع الاتصال</button>
            </div>
          </div>
        ) : (
          <>
            {/* Step indicators */}
            <div style={{display:"flex",gap:6,marginBottom:20}}>
              {[1,2,3].map(n=>(
                <div key={n} style={{flex:1,textAlign:"center"}}>
                  <div style={{width:28,height:28,borderRadius:"50%",margin:"0 auto 5px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:800,
                    background:step===n?"linear-gradient(135deg,#a78bfa,#7c3aed)":step>n?"rgba(34,197,94,0.2)":"rgba(255,255,255,0.06)",
                    color:step===n?"#fff":step>n?"#22c55e":"#64748b"}}>
                    {step>n?"✓":n}
                  </div>
                  <div style={{fontSize:10,color:step===n?"#a78bfa":"#475569",fontWeight:step===n?700:400}}>
                    {n===1?"أنشئ مشروعاً":n===2?"أنشئ الجدول":"ربط"}
                  </div>
                </div>
              ))}
            </div>

            {/* Step 1 */}
            {step===1&&(
              <div>
                <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)",borderRadius:12,padding:"16px",marginBottom:16,fontSize:13,color:"#94a3b8",lineHeight:2}}>
                  <b style={{color:"#e2e8f0"}}>١.</b> اذهب إلى <a href="https://supabase.com" target="_blank" rel="noreferrer" style={{color:"#22c55e"}}>supabase.com</a> وسجّل مجاناً<br/>
                  <b style={{color:"#e2e8f0"}}>٢.</b> انقر <b style={{color:"#a78bfa"}}>New Project</b> وأعطه أي اسم<br/>
                  <b style={{color:"#e2e8f0"}}>٣.</b> انتظر حتى يكتمل الإعداد (دقيقة واحدة)
                </div>
                <button onClick={()=>setStep(2)} style={{width:"100%",padding:"11px",borderRadius:10,background:"linear-gradient(135deg,#a78bfa,#7c3aed)",border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>التالي ←</button>
              </div>
            )}

            {/* Step 2 */}
            {step===2&&(
              <div>
                <div style={{fontSize:13,color:"#94a3b8",lineHeight:1.8,marginBottom:12}}>
                  في مشروعك → <b style={{color:"#e2e8f0"}}>SQL Editor</b> → انقر <b style={{color:"#a78bfa"}}>New Query</b> → الصق هذا الكود وشغّله:
                </div>
                <div style={{position:"relative",marginBottom:16}}>
                  <pre style={{background:"rgba(0,0,0,0.5)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:10,padding:"14px",fontSize:12,color:"#22c55e",overflowX:"auto",margin:0,direction:"ltr",textAlign:"left",lineHeight:1.7}}>
                    {SQL}
                  </pre>
                  <button onClick={()=>navigator.clipboard.writeText(SQL)}
                    style={{position:"absolute",top:8,left:8,padding:"3px 10px",borderRadius:6,background:"rgba(167,139,250,0.15)",border:"1px solid rgba(167,139,250,0.3)",color:"#a78bfa",fontSize:11,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>
                    نسخ
                  </button>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setStep(1)} style={{padding:"10px 20px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"#64748b",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>رجوع</button>
                  <button onClick={()=>setStep(3)} style={{flex:1,padding:"10px",borderRadius:10,background:"linear-gradient(135deg,#a78bfa,#7c3aed)",border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>نفّذت SQL ←</button>
                </div>
              </div>
            )}

            {/* Step 3 */}
            {step===3&&(
              <div>
                <div style={{fontSize:13,color:"#94a3b8",lineHeight:1.8,marginBottom:12}}>
                  من مشروعك → <b style={{color:"#e2e8f0"}}>Settings → API</b> → انسخ:
                </div>
                <div style={{marginBottom:12}}>
                  <label style={{display:"block",fontSize:11,color:"#94a3b8",marginBottom:5}}>Project URL</label>
                  <input value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://xxxxxxxxxxxx.supabase.co" style={IS}/>
                </div>
                <div style={{marginBottom:16}}>
                  <label style={{display:"block",fontSize:11,color:"#94a3b8",marginBottom:5}}>anon public key</label>
                  <input value={anonKey} onChange={e=>setAnonKey(e.target.value)} placeholder="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." style={IS}/>
                </div>
                {testErr&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.25)",borderRadius:9,padding:"9px 14px",marginBottom:12,fontSize:12,color:"#fca5a5"}}>❌ {testErr}</div>}
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setStep(2)} style={{padding:"10px 20px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"#64748b",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>رجوع</button>
                  <button onClick={testAndSave} disabled={testing||!url||!anonKey}
                    style={{flex:1,padding:"10px",borderRadius:10,background:url&&anonKey?"linear-gradient(135deg,#22c55e,#15803d)":"rgba(255,255,255,0.05)",border:"none",color:url&&anonKey?"#fff":"#334155",fontSize:14,fontWeight:800,cursor:url&&anonKey?"pointer":"not-allowed",fontFamily:"'Tajawal',sans-serif"}}>
                    {testing?"⏳ اختبار الاتصال…":"✅ ربط وتفعيل المزامنة"}
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export function BackupModal({ onClose, onExport, onImport, importError, importSuccess, onGoogleSignIn, sbConfigured }){
  const {S, lang} = useLang();
  const T = S.backup;
  const fileRef = useRef(null);
  return(
    <div style={{position:"fixed",inset:0,zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.8)",backdropFilter:"blur(6px)"}}>
      <div dir="rtl" style={{background:"#181b27",border:"1px solid rgba(56,189,248,0.25)",borderRadius:20,width:"min(460px,93vw)",padding:32,fontFamily:"'Tajawal',sans-serif"}}>

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
          <span style={{fontSize:18,fontWeight:800,color:"#38bdf8"}}>{T.title}</span>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#64748b",fontSize:20,cursor:"pointer"}}>✕</button>
        </div>

        {/* Google Sign In */}
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:"16px 20px",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:700,color:"#e2e8f0",marginBottom:6}}>{T.googleTitle}</div>
          <div style={{fontSize:12,color:"#64748b",lineHeight:1.8,marginBottom:12}}>
            {T.googleDesc}
          </div>
          <button onClick={onGoogleSignIn}
            style={{width:"100%",padding:"11px",borderRadius:10,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.15)",color:"#e2e8f0",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"'Tajawal',sans-serif",display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            {sbConfigured ? "دخول بـ Google" : "اربط Supabase أولاً ثم سجّل بـ Google"}
          </button>
        </div>

        {/* Export */}
        <div style={{background:"rgba(34,197,94,0.07)",border:"1px solid rgba(34,197,94,0.2)",borderRadius:14,padding:"18px 20px",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:700,color:"#22c55e",marginBottom:6}}>📤 تصدير البيانات</div>
          <div style={{fontSize:12,color:"#64748b",lineHeight:1.8,marginBottom:12}}>
            {T.exportDesc1}
            {T.exportDesc2}
          </div>
          <button onClick={onExport}
            style={{width:"100%",padding:"11px",borderRadius:10,background:"linear-gradient(135deg,#22c55e,#15803d)",border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>
            {T.downloadBtn}
          </button>
        </div>

        {/* Import */}
        <div style={{background:"rgba(56,189,248,0.07)",border:`1px solid ${importError?"rgba(239,68,68,0.3)":importSuccess?"rgba(34,197,94,0.3)":"rgba(56,189,248,0.2)"}`,borderRadius:14,padding:"18px 20px"}}>
          <div style={{fontSize:14,fontWeight:700,color:"#38bdf8",marginBottom:6}}>{T.importTitle}</div>
          <div style={{fontSize:12,color:"#64748b",lineHeight:1.8,marginBottom:12}}>
            {T.importDesc}
            <span style={{color:"#f59e0b",display:"block",marginTop:4}}>{T.importWarn}</span>
          </div>

          {importSuccess&&(
            <div style={{background:"rgba(34,197,94,0.12)",border:"1px solid rgba(34,197,94,0.3)",borderRadius:9,padding:"10px 14px",marginBottom:10,fontSize:13,color:"#22c55e",fontWeight:700,textAlign:"center"}}>
              {T.importOk}
            </div>
          )}
          {importError&&(
            <div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.25)",borderRadius:9,padding:"10px 14px",marginBottom:10,fontSize:13,color:"#fca5a5"}}>
              ❌ {importError}
            </div>
          )}

          <input ref={fileRef} type="file" accept=".json" onChange={e=>onImport(e.target.files[0])} style={{display:"none"}}/>
          <button onClick={()=>fileRef.current.click()}
            style={{width:"100%",padding:"11px",borderRadius:10,background:"rgba(56,189,248,0.12)",border:"1px solid rgba(56,189,248,0.3)",color:"#38bdf8",fontSize:14,fontWeight:800,cursor:"pointer",fontFamily:"'Tajawal',sans-serif"}}>
            {T.chooseFile}
          </button>
        </div>

        {/* Tip */}
        <div style={{marginTop:16,fontSize:11,color:"#334155",textAlign:"center",lineHeight:1.7}}>
          {T.tip}<br/>
          {T.autoSave}
        </div>
      </div>
    </div>
  );
}
